import { HttpInterceptorFn } from '@angular/common/http';
import { retry, timer } from 'rxjs';

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: 3,
      delay: (error, retryCount) => {
        if (error.status === 401 || error.status === 403 || error.status === 400 || error.status >= 500) {
          throw error;
        }
        return timer(Math.pow(2, retryCount) * 1000);
      }
    })
  );
};
